import { render, staticRenderFns } from "./ExtensionInstall.vue?vue&type=template&id=ef3f6d36&scoped=true&"
import script from "./ExtensionInstall.vue?vue&type=script&lang=js&"
export * from "./ExtensionInstall.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionInstall.vue?vue&type=style&index=0&id=ef3f6d36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3f6d36",
  null
  
)

export default component.exports